import { TranslateService } from '@ngx-translate/core';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Global } from "./global";
//import * as moment from 'moment';
declare let moment: any;

declare let PNotify: any;

@Injectable()
export class Funcoes {

  erroRedir = ["semPrivilegioAcesso", "usuarioBloqueado", "tokenExpirado", "tokenInvalido"];

  constructor(
    private translate: TranslateService,
    private router: Router,
    public global: Global
  ) {
  }

  traduzir(palavra, obj = null) {
    let retorno = '';
    this.translate.get(palavra, obj).subscribe((result) => retorno = result).unsubscribe();
    return retorno;
  }

  // verifica se objeto é vazio
  isEmptyObject(obj) {
    let name;
    for (name in obj) {
      return false;
    }
    return true;
  }

  // verifica se é objeto
  isObject(obj) {
    return obj === Object(obj);
  }

  // verifica se é vazio
  isEmpty(str) {
    return (!str || 0 === str.length);
  }

  // exibr alerta quando tiver erros
  showErro(message, form = null) {

    if (this.global.debug == true) {
      //console.log(message);
      //console.log(message.Errors);
      //console.log(message.Message.Errors);
      //console.log((!this.isEmptyObject(message.Errors)));
    }

    if (!this.isEmptyObject(message.Message)) {
      console.log('sim');
      message = message.Message;
    }

    // Exibir erros no alert
    if (!this.isEmptyObject(message.Errors)) {
      let lista = '<ul style="list-style: none; padding: 0;">';
      for (let i in message.Errors) {
        if (this.isObject(message.Errors[i])) {

          let objErro = {};
          for (let x in message.Errors[i]) {
            objErro[x] = message.Errors[i][x];
          }


          if (this.erroRedir.indexOf(i) >= 0) {

            if (this.getTokenInfo()['adm'] == 1) {
              this.router.navigateByUrl('/nao-autorizado');
            } else {
              this.router.navigateByUrl('/nao-autorizado-cliente');
            }
          }

          lista += '<li>' + this.traduzir('back.' + i, objErro) + '</li>';

        } else {
          lista += '<li>' + message.Errors[i] + '</li>';
        }
      }
      lista += '</ul>';

      new PNotify({
        title: this.traduzir('back.' + message.Title),
        text: lista,
        addclass: 'bg-danger',
        icon: 'icon-warning22'
      });
    }
  }

  // exibr alerta quando for sucesso
  showSucesso(message) {

    if (typeof message === 'string') {
      if (message !== '') {
        new PNotify({
          title: message,
          text: '',
          addclass: 'bg-success',
          icon: 'icon-checkmark',
          sticker: false,
          sticker_hover: false
        });
      }
      return;
    }

    if (message && message.Title) {
      let titleTraduzido = this.traduzir('back.' + message.Title);
      if (titleTraduzido === 'back.' + message.Title) {
        titleTraduzido = this.traduzir('front.' + message.Title);
      }
      if (titleTraduzido === 'front.' + message.Title) {
        titleTraduzido = message.Title;
      }

      new PNotify({
        title: titleTraduzido,
        text: '',
        addclass: 'bg-success',
        icon: 'icon-checkmark',
        sticker: false,
        sticker_hover: false
      });
    }
  }

  // retorna array principal do token
  getTokenInfo() {
    let token = localStorage.getItem('token');

    if (this.global.debug == true) {
      //console.log(token);
    }

    return JSON.parse(atob(token.split('.')[1]));
  }

  formatDate(formato, valor, userInfo) {

    if (!valor || valor == 'Invalid date') {
      return '';
    }

    let retorno = '';

    switch (formato) {
      case 'data':
        retorno = moment(valor, 'YYYY-MM-DD').format(userInfo.date_format);
        break;

      case 'dataHora':
        retorno = moment(valor, 'YYYY-MM-DD HH:mm').format(userInfo.date_format + ' ' + userInfo.time_format);
        break;

      case 'hora':
        retorno = moment(valor, 'HH:mm').format(userInfo.time_format);
        break;
    }

    return retorno;
  }

  formatSendDate(formato, valor, userInfo) {

    if (!valor || valor == 'Invalid date') {
      return '';
    }

    let retorno = '';

    switch (formato) {
      case 'data':
        retorno = moment(valor, userInfo.date_format).format('YYYY-MM-DD');
        break;

      case 'dataHora':
        retorno = moment(valor, userInfo.date_format + ' ' + userInfo.time_format).format('YYYY-MM-DD HH:mm');
        break;

      case 'hora':
        retorno = moment(valor, userInfo.time_format).format('HH:mm');
        break;
    }

    return retorno;
  }

  // gerador de UUID
  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + s4() + s4() + s4() + s4();
  }

  // clona objeto
  cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  // mescla 2 objetos em 1
  mergeObj(obj1, obj2) {
    let obj3 = {};
    for (let attrname in obj1) { obj3[attrname] = obj1[attrname]; }
    for (let attrname in obj2) { obj3[attrname] = obj2[attrname]; }
    return obj3;
  }

  // mescla 2 arrays de objetos com a mesma propriedade
  mergeObjByProp(a, b, prop) {
    let reduced = a.filter(function (aitem) {
      return !b.find(function (bitem) {
        return aitem[prop] === bitem[prop];
      });
    });
    return reduced.concat(b);
  }

  validaEmail(email) {
    let re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,16}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  // exibe alerta
  alerta(title, texto = '', tipo = 'sucesso') {

    let classe = 'bg-success';
    let icone = 'icon-checkmark4';


    if (tipo == 'erro') {
      classe = 'bg-danger';
      icone = 'icon-warning22';
    }

    new PNotify({
      title: title,
      text: texto,
      addclass: classe,
      icon: icone
    });
  }

  // retorna um array sem valores duplicados
  uniqueArray(array) {
    return array.filter((v, i, a) => a.indexOf(v) === i);
  }

  // retorna o nome do tipo de transporte
  nomeTipoTransporte(nome) {
    switch (nome) {
      case 'm':
        return this.traduzir('front.maritimo');
      case 'a':
        return this.traduzir('front.aereo');
      case 'r':
        return this.traduzir('front.rodoviario');
      default:
        return '';
    }
  }

  // retorna formatação do container
  formatContainer(v) {
    return v.substring(0, 4) + '-' + v.substring(4, 10) + '-' + v.substring(10, 11);
  }

  formatCalibre(val: string): string {
    if (!val) return '';
    return val.split(',').map(v => v.trim()).filter(v => v !== '').join(' | ');
  }

  consoleLog(v) {
    console.log(v);
  }

  // calcula os indices de classificacao
  calculaIndicesClassificacao(indices, defeitos) {

    let retorno = [];
    let sucesso = false;

    for (let i in defeitos) {
      sucesso = false;

      for (let x in indices) {

        if (defeitos[i].id_defeito == indices[x].id_defeito) {

          if (indices[x].percentual_tipo == 'max') {
            if (defeitos[i].valor <= indices[x].percentual) {
              retorno[defeitos[i].id_defeito] = indices[x].nome;
              sucesso = true;
              break;
            }
          } else if (indices[x].percentual_tipo == 'min') {
            if (defeitos[i].valor >= indices[x].percentual) {
              retorno[defeitos[i].id_defeito] = indices[x].nome;
              sucesso = true;
              break;
            }
          }
        }
      }

      if (!sucesso) {
        retorno[defeitos[i].id_defeito] = this.traduzir('front.nenhumIndiceEncontrado');
      }

    }

    console.log('list indices', retorno);
    return retorno;
  }

  // calcula o indice geral de classificacao de uma ficha
  calculaIndiceGeralClassificacao(indices, defeitos, indicesClassificacaoCalculado) {

    console.log('listIndicesClassificacao AQUI', indices);
    console.log('defeitos AQUI', defeitos);
    let retorno = [];
    let tipo = 0;

    for (let x in defeitos) {

      if (defeitos[x]['ativo'] && indicesClassificacaoCalculado[defeitos[x]['id_defeito']] != this.traduzir('front.nenhumIndiceEncontrado')) {
        let i = 0;

        for (let y in indices) {

          if (defeitos[x]['id_defeito'] == indices[y]['id_defeito']) {

            i++;

            if (indices[y]['percentual_tipo'] == 'max') {
              if (defeitos[x]['valor'] <= indices[y]['percentual']) {
                if (tipo < i) {
                  tipo = i;
                  retorno["nome"] = indices[y]['nome'];
                  retorno["cor"] = indices[y]['cor'];
                  retorno["indice"] = i;
                }
                break;
              }
            } else if (indices[y]['percentual_tipo'] == 'min') {
              if (defeitos[x]['valor'] >= indices[y]['percentual']) {
                if (tipo < i) {
                  tipo = i;
                  retorno['nome'] = indices[y]['nome'];
                  retorno["cor"] = indices[y]['cor'];
                  retorno["indice"] = i;
                }
                break;
              }
            }

          }
        }
      }

    }

    return retorno;
  }

  // calcula o tipo ou categoria
  calculaIndiceClassificacaoGeral(indices_conclusao, indices_classificacao, defeitos, indicesClassificacaoCalculado) {

    let indice_geral = 0;
    let txt_indice_geral = 'Não Encontrado';

    for (let i in indices_conclusao) {
      if (indices_conclusao[i].classificar) {
        if (parseInt(indices_conclusao[i]['ordem_classificacao']) > indice_geral) {
          indice_geral = parseInt(indices_conclusao[i]['ordem_classificacao']);
          txt_indice_geral = indices_conclusao[i]['valorGeral'];
        }
      }
    }

    let listIndicesClassificacaoCalculado = this.calculaIndiceGeralClassificacao(indices_classificacao, defeitos, indicesClassificacaoCalculado);

    return (listIndicesClassificacaoCalculado['indice'] <= indice_geral) ? txt_indice_geral : listIndicesClassificacaoCalculado['nome'];
  }

  userIsMaster(): boolean {
    return (this.getTokenInfo()['master'] == 1);
  }

  salvaFiltroPesquisaAvancada(pagina, nome, filtro) {
    sessionStorage.setItem('pagina' + nome, pagina);
    sessionStorage.setItem(nome, JSON.stringify(filtro));
  }

  pegaFiltroPesquisaAvancada(nome) {
    let r = {};
    r['pagina'] = JSON.parse(sessionStorage.getItem('pagina' + nome));
    r['filtro'] = JSON.parse(sessionStorage.getItem(nome));
    return r;
  }

  nomeStatusSolicitacao(status) {

    let retorno = this.traduzir('front.indefinido');

    switch (status) {
      case 1:
        retorno = this.traduzir('front.enviada');
        break;
      case 3:
        retorno = this.traduzir('front.processamento');
        break;
      case 5:
        retorno = this.traduzir('front.amostraEviadaLaboratorio');
        break;
      case 10:
        retorno = this.traduzir('front.emitida');
    }

    return retorno;
  }

  nomesStatusSolicitacao() {
    return [{
      "nome": this.traduzir('front.enviada'),
      "valor": 1
    }, {
      "nome": this.traduzir('front.emProcessamento'),
      "valor": 3
    }, {
      "nome": this.traduzir('front.amostraEviadaLaboratorio'),
      "valor": 5
    }, {
      "nome": this.traduzir('front.emitida'),
      "valor": 10
    }]
  }

  nomeStatusCertificado(status) {

    let retorno = this.traduzir('front.indefinido');

    switch (status) {
      case 1:
        retorno = this.traduzir('front.processamento');
        break;
      case 5:
        retorno = this.traduzir('front.prontoEmitir');
        break;
      case 10:
        retorno = this.traduzir('front.emitido');
    }

    return retorno;
  }

  nomesStatusCertificado() {
    return [{
      "nome": this.traduzir('front.processamento'),
      "valor": 1
    }, {
      "nome": this.traduzir('front.prontoEmitir'),
      "valor": 5
    }, {
      "nome": this.traduzir('front.emitido'),
      "valor": 10
    }]
  }

  siglasEstados() {
    return [
      'AC',
      'AL',
      'AP',
      'AM',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MT',
      'MS',
      'MG',
      'PA',
      'PB',
      'PR',
      'PE',
      'PI',
      'RJ',
      'RN',
      'RS',
      'RO',
      'RR',
      'SC',
      'SP',
      'SE',
      'TO'
    ]
  }

  nomesFormasAcondicionamento() {
    return [
      "A GRANEL",
      "BIG BAG",
      "BOPP+PE",
      "FARDOS",
      "FLEXTANK",
      "JUTA",
      "LATA",
      "MADEIRA",
      "NI",
      "PALLETS",
      "PAPEL",
      "PAPELÃO",
      "PlÁSTICO",
      "POLIETILENO",
      "POLIPROPILENO",
      "RÁFIA",
      "SACOS",
      "VIDRO",
      "TAMBOR"
    ]
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  formataPeso(v) {
    return parseFloat(v).toLocaleString('pt-BR');
  }

  ifIE() {
    return (/*@cc_on!@*/false || !!document['documentMode']);
  }

  primeiroDiaMes(data) {
    let d = new Date(data);
    return new Date(d.getFullYear(), d.getMonth(), 1).setHours(0, 0, 0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/funcoes.ts